import './style.scss'
import dayjs from 'dayjs'
import { FC, memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { UserStore } from '@/global-states'

const UserModalHeader: FC = () => {
  const { t: translate } = useTranslation(['user_header'])
  const { phone, userPackage } = UserStore

  const vip = useMemo(() => {
    return !!userPackage?.membership_expire_time
  }, [userPackage])

  const vipExpired = useMemo(() => {
    return !!userPackage?.membership_expired
  }, [userPackage])

  return (
    <div className="user-content-header">
      <div className="photo">
        <span className="gradient">{translate('user_header.greeting')}</span>
      </div>
      <div className="user-info">
        <div className="phone">
          <label>{phone}</label>
        </div>
        {vip && userPackage ? (
          <>
            {vipExpired ? (
              <label className="text gray">
                {translate('user_header.package_expired', {
                  date: dayjs(userPackage.membership_expire_time * 1000).format('YYYY-MM-DD HH:mm')
                })}
              </label>
            ) : (
              <label className="text">
                {translate('user_header.expiry_time', {
                  date: dayjs(userPackage.membership_expire_time * 1000).format('YYYY-MM-DD HH:mm')
                })}
              </label>
            )}
          </>
        ) : (
          <label className="text">{translate('user_header.no_membership')}</label>
        )}
      </div>
    </div>
  )
}

export default memo(UserModalHeader)
